import { IBid, Bid } from "./IBid";
import { ISupplierResponse } from "./ISupplierResponse"
import { ISample } from "./ISample";
import { ISampleBlend } from "./ISampleBlend";

export interface IBidResponse {
    request: IBid;
    duration: string;
    feasibilities: ISupplierResponseTypes;
    sampleBlends: ISampleBlendType;
    maxSampleBlends: ISampleBlendType;
    _correlationId: string;
}

export class BidResponse {
    request: IBid;
    duration: string;
    feasibilities: ISupplierResponseTypes;
    sampleBlends: ISampleBlendType;
    maxSampleBlends: ISampleBlendType;
    _correlationId: string;

    constructor() {
        this.request = new Bid();
        this.feasibilities = new SupplierResponseTypes();
        this.sampleBlends = new ISampleBlendType();
        this.maxSampleBlends = new ISampleBlendType();
    }
}

export class ISupplierResponseTypes {
    [id: string]: Array<ISample>;

}

export class SupplierResponseTypes {
    [id: string]: Array<ISample>;
}

export class ISampleBlendType {
    [id: string]: ISampleBlend;
}



// WEBPACK FOOTER //
// ./src/app/models/IBidResponse.ts